import React, { Children, cloneElement, useEffect } from 'react';
import { getVersion } from '@/apis';
import { Modal } from 'antd';
// import { localStorage } from "@/storage";

import { useTranslation } from '@/i18n';
import { init } from 'i18next';

// 创建 context 对象
interface VersionUpdateProps {
    children: React.ReactNode;
    history: {
        listen: (callback: (location: { location: any }) => void) => void;
    };
}

interface VersionResponse {
    data: {
        version: string;
    };
}

export default (props: VersionUpdateProps) => {
    const { children, history, listen = () => {} } = props;

    const { t } = useTranslation('common');

    const init = async () => {
        const {
            data: { version },
        }: VersionResponse = await getVersion();
        localStorage.setItem('version', version);

        listen(async () => {
            const {
                data: { version },
            }: VersionResponse = await getVersion();

            const oldVersion = localStorage.getItem('version');

            if (oldVersion && version && oldVersion !== version) {
                // 如果版本号不一致，刷新网站
                localStorage.setItem('version', version);
                setTimeout(() => {
                    window.location.reload(true);
                }, 100);
                // Modal.confirm({
                //     title: t("VersionUpdateTitle"),
                //     content: t("VersionUpdateHint"),
                //     onOk: () => {
                //         localStorage.setItem("version", version);
                //         setTimeout(() => {
                //             window.location.reload(true);
                //         }, 100);
                //     },
                //     footer: (
                //         _,
                //         {
                //             OkBtn,
                //             CancelBtn,
                //         }: {
                //             OkBtn: React.FC;
                //             CancelBtn: React.FC;
                //         },
                //     ) => (
                //         <>
                //             {/* <Button>Custom Button</Button> */}
                //             {/* <CancelBtn /> */}
                //             <OkBtn>{t("confirm")}</OkBtn>
                //         </>
                //     ),
                // });
            }
        });
    };

    useEffect(() => {
        init();
    }, []);

    return Children.map(children, (child) => {
        if (React.isValidElement(child)) {
            return cloneElement(child, {}); // Assuming `more` is an empty object for now
        }
        return child; // Return non-ReactElement nodes as-is
    });
};
